// Misc
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

// Atoms
import Hidden from '@material-ui/core/Hidden'
import Svg from 'atoms/Svg'

// Images
import logoSvg from 'assets/logo.svg'

// Styles
const styles = theme => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  widget: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  message: {
    background: '#fff',
    maxWidth: 375,
    minWidth: 60,
    marginBottom: 20,
    boxShadow: '0 5px 20px 5px rgba(0, 0, 0, 0.05)',
    borderRadius: 8,
    padding: 16,
    color: '#383838',
    fontFamily: '"Open Sans", sans-serif',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '1.4em',
    wordWrap: 'break-word',
  },
  button: {
    background: theme.palette.primary.main,
    width: 60,
    height: 60,
    borderRadius: '50%',
    textAlign: 'center',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      width: 46,
      height: 20,
    }
  },
})

export default
@withStyles(styles)
class OnboardingWelcomeMessageStepWidget extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    welcomeMessage: PropTypes.string,
  }

  render() {
    const { classes, welcomeMessage } = this.props
    return (
      <Hidden smDown>
        <div className={classes.root}>
          <div className={classes.widget}>
            <div className={classes.message}>
              { welcomeMessage || 'Hey there 👋 thanks for stopping by!' }
            </div>
            <div className={classes.button}>
              <Svg {...logoSvg} />
            </div>
          </div>
        </div>
      </Hidden>
    )
  }
}
